import { application } from "./controllers/application";

import PasswordStrengthController from "./controllers/password_strength_controller";

application.register("password-strength", PasswordStrengthController);
